module.exports = __webpack_public_path__ + "static/vegan-cola_og_image-fbf20709a321e0ee5d1a14a364219d19.jpg";